import { render, staticRenderFns } from "./ListedCheckbox.vue?vue&type=template&id=63bb28d6&scoped=true"
import script from "./ListedCheckbox.vue?vue&type=script&lang=js"
export * from "./ListedCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ListedCheckbox.vue?vue&type=style&index=0&id=63bb28d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb28d6",
  null
  
)

export default component.exports